import React from "react";
import Sidebar from "./Sidebar";
import "./Dashboard.css";
import { Outlet, Link, useLocation } from "react-router-dom";
import DashboardHome from "./DashboardHome";

const AdminDashboard = () => {
  const location = useLocation();
  const isDashboardHome = location.pathname === "/dashboard";

  return (
    <div className="admin-dashboard-hy-container">
      <Sidebar />
      <div className="admin-dashboard-hy-main-content">
        <header className="admin-dashboard-hy-header">
          <div className="admin-dashboard-hy-header-content">
            <h1 className="admin-dashboard-hy-title">
              <span className="admin-dashboard-hy-title-icon">🏛️</span>
              HeyatYolu Admin Panel
            </h1>
            <Link to="/" className="admin-dashboard-hy-site-link">
              <svg className="admin-dashboard-hy-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
              </svg>
              Sayta qayıt
            </Link>
          </div>
        </header>
        <div className="admin-dashboard-hy-content-wrapper">
          {isDashboardHome ? <DashboardHome /> : <Outlet />}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;